<template>
    <div id="report">
        <h2>Rapportages</h2>
        <form v-on:submit.prevent="submitReport">
            <div class="form-group">
                <label for="report" >Soort Rapport</label>
                <select class="form-control" v-model="report.reportType" :disabled="report.locked">
                    <option value="Dienstrapport">Dienstrapport</option>
                    <option value="Specifiekrapport">Specifiek Rapport</option>
                </select>
            </div>
            <div class="form-group">
                <label for="report" >Datum Dienst</label>
                <select class="form-control" v-model="report.reportDate" :disabled="report.locked" >
                    <option :value="d.date" v-for="d in assignment.dates" :key="d.id">{{new Date(d.date).toLocaleDateString()}}</option>
                </select>
            </div>
            <div class="form-group">
                <label for="subject" >Onderwerp</label>
                <input type="text" class="form-control" id="subject" placeholder="Met een paar woorden de inhoud weergeven..." v-model="report.subject" :disabled="report.locked" />
            </div>
            <div class="form-group">
                <label for="report" >Rapport</label>
                <textarea type="text" class="form-control" id="report" rows="10" placeholder="Op (datum), omstreeks (tijdstip) bevond ik mij..."  v-model="report.message"  :disabled="report.locked"></textarea>
            </div>
            <div class="form-group">
                <label for="report" >Interne Aantekeningen</label>
                <textarea type="text" class="form-control" id="report" rows="5" placeholder="Deze inhoud wordt niet met de opdrachtgever gedeeld."  v-model="report.internalComments"  :disabled="report.locked"></textarea>
            </div>
            <div class="form-group text-center">
                <label class="btn btn-outline-azure-dark btn-file btn-lg" :hidden="report.locked">
                    <font-awesome-icon icon="camera"></font-awesome-icon>&nbsp;&nbsp;Foto's of bijlagen<input multiple type="file" style="display: none;" @change="addAttachement" />
                </label>
                <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between" v-for="(a, idx) in report.attachments" :key="idx">
                        <span class="pt-1 ellipsis">{{a.name}}</span>
                        <button type="button" class="btn btn-danger btn-round btn-sm" @click="removeAttachment" v-if="!report.locked">
                            <font-awesome-icon icon="trash-alt"></font-awesome-icon>
                        </button>
                        <button type="button" class="btn btn-outline-azure-dark btn-round btn-sm" @click="downloadAttachment(a)" v-if="report.locked">
                            <font-awesome-icon :icon="['fa', 'file-download']"></font-awesome-icon>
                        </button>
                    </li>
                </ul>
            </div>
            <div class="form-group text-right">
                <loader width="2rem" v-if="isLoading"></loader>
                <button type="button" class="btn btn-outline-azure-dark mr-2" @click="clearReport" :disabled="isLoading">Leegmaken</button>
                <button type="submit" class="btn btn-azure-dark" :disabled="report.locked || isLoading">Indienen</button>
            </div>
        </form>
        <hr v-if="reports.length > 0" />
        <h3 v-if="reports.length > 0">Ingediend</h3>
        <div class="text-center" v-if="isLoadingReports">
            <loader width="3rem"></loader>
        </div>
        <div class="list-group">
            <div class="list-group-item list-group-item-action flex-column align-items-start" v-for="r in reports" :key="r.id" @click="selectReport(r)">
                <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1 ellipsis">{{r.subject}}</h5>
                <small class="invisible-sm">Ingediend op: {{new Date(r.submitDate).toLocaleDateString() + ' ' + new Date(r.submitDate).toLocaleTimeString()}}</small>
                </div>
                <p class="mb-1">{{r.message.substring(0, 50)}}...</p>
                <small>{{r.reportType}} {{new Date(r.reportDate).toLocaleDateString()}}</small>
            </div>
        </div>
    </div>
</template>

<script>
import { report, document } from '@/models/models.js';
import Loader from '@/components/Loader'

export default 
{
    components: {
        Loader
    },
    data() {
        return {
            isLoading: false,
            isLoadingReports: false,
            report: {},
            reports: []
        }
    },
    mounted() {
        this.report = new report({ assignmentId: this.assignment.id });
        this.getReports();
    },
    methods: {
        selectReport(report) {
            this.report = report;
        },
        submitReport() {
            this.isLoading = true;
            this.report.submitDate = new Date();
            this.report.locked = true;

            let formData = new FormData();

            for (let key in this.report) {
                if(key == 'attachments')
                {
                    this.report[key].forEach((a) => {
                        formData.append(a.name, a);
                    });
                } else 
                {
                    formData.append(key, this.report[key]);
                }
            }

            return this.$http.post('api/Report/' + this.report.assignmentId, formData).then((res) => {
                this.reports.push(this.report);
                this.isLoading = false;
                return this.clearReport();
            }).catch(() => {
                this.report.locked = false;
                this.isLoading = false;
            });
        },
        clearReport() {
            return this.report = new report({ assignmentId: this.assignment.id });
        },
        getReports() {
            if(this.assignment.id) {
                this.isLoadingReports = true;
                return this.$http.get('api/Report/Reports/' + this.assignment.id).then((res) => {
                    this.isLoadingReports = false;
                    return this.reports = res.data.map((r) => { 
                        r.attachments = r.attachments.map(a => { return { id: a.id, name: a.fileName.split('/')[a.fileName.split('/').length-1], size: a.fileSize }});
                        return new report(r); 
                    });
                }).catch(() => {
                    this.isLoadingReports = false;
                });
            }
        },
        addAttachement(ev) {
            for(let i = 0; i < ev.currentTarget.files.length; i++) 
            {
                this.report.attachments.push(ev.currentTarget.files[i]);
            }
        },
        removeAttachment(attachment)
        {
            this.report.attachments.splice(this.report.attachments.indexOf(attachment), 1);
        },
        downloadAttachment(attachment)
        {
            return this.$http.get('api/Report/Attachment/' + this.report.id + '/' + attachment.id, { responseType: 'blob' }).then((res) => {
                let blob = new Blob([res.data], { type: res.headers.get('content-type') });

                let link = window.document.createElement("a");
                link.href = window.URL.createObjectURL(blob);

                link.download = attachment.name;

                window.document.body.appendChild(link);

                link.click();

                window.document.body.removeChild(link);
            })
        },
    },
    computed: {
        assignment() {
            return this.$parent.assignment;
        }
    },
    watch: {
        assignment(to) {
            if(to)
            {
                this.report.reportDate = to.dates[0].date;
                this.getReports();
            }   
        }
    }
}
</script>